import React, { FC, useMemo, useState } from 'react';
import { FaBullhorn, FaCreditCard, FaRegFileAlt } from 'react-icons/fa';
import { TabItem, Tabs } from '@/lib';
import { CampaignsInnerRoutePlaceholderV2 } from './CampaignsInnerRoutePlaceholderV2';

const EMAIL_CAMPAIGNS_TAB = 'campaign:whatsappWorkspace.campaigns' as const;
const EMAIL_TEMPLATES_TAB = 'campaign:whatsappWorkspace.templates' as const;
const EMAIL_PACKAGES_TAB = 'campaign:whatsappWorkspace.packages' as const;

export const CampaignsEmailWorkspaceV2: FC = () => {
  const tabItems = useMemo<TabItem[]>(
    () => [
      {
        id: 'campaigns',
        title: EMAIL_CAMPAIGNS_TAB,
        icon: <FaBullhorn className='size-4' />,
        count: 'N/A',
        element: <CampaignsInnerRoutePlaceholderV2 title='Email campaigns' description='Email campaigns workspace will be available soon.' />,
      },
      {
        id: 'templates',
        title: EMAIL_TEMPLATES_TAB,
        icon: <FaRegFileAlt className='size-4' />,
        count: 'N/A',
        element: <CampaignsInnerRoutePlaceholderV2 title='Email templates' description='Email templates workspace will be available soon.' />,
      },
      {
        id: 'packages',
        title: EMAIL_PACKAGES_TAB,
        icon: <FaCreditCard className='size-4' />,
        count: 'N/A',
        element: <CampaignsInnerRoutePlaceholderV2 title='Email packages' description='Email package management will be available soon.' />,
      },
    ],
    []
  );
  const [currentTabTitle, setCurrentTabTitle] = useState(tabItems[0].title);
  const currentTab = tabItems.find((item) => item.title === currentTabTitle) ?? tabItems[0];

  const handleSelectTab = (tabItem: TabItem) => {
    setCurrentTabTitle(tabItem.title);
  };

  return <Tabs items={tabItems} currentTab={currentTab.title} onSelectTab={handleSelectTab} />;
};
